export var hasSearchResults = function hasSearchResults(searchItems) {
  var sectionsWithSearchResults = searchItems.sections.filter(function (_ref) {
    var searchResults = _ref.searchResults;
    return searchResults.length > 0;
  });
  return sectionsWithSearchResults.length > 0;
};